import {ListUtility} from '../../../Utils/ListUtility'
import {UrlUtility} from "../../../Utils/UrlUtility"

interface bucketListItemJSON {
  id: number
  bucketKey: string
  name: string
  urlList: bucketUrl[]
}

type bucketUrl = {
  type: string
  url: string
  urlReplaceStyle: string
}

export interface BucketListItem {
  id: number
  bucketKey: string
  name: string
  logoImgUrl: string
}

export interface AdministratorInformationJSON {
  bucketList: bucketListItemJSON[]
  isSystemAdministrator: boolean
}

export interface AdministratorInformation {
  bucketList: BucketListItem[]
  isSystemAdministrator: boolean
}

export class AdministratorInformationDTO implements AdministratorInformation {
  bucketList: BucketListItem[]
  isSystemAdministrator: boolean

  constructor(
    bucketList: BucketListItem[],
    isSystemAdministrator: boolean,
  ) {
    this.bucketList = bucketList
    this.isSystemAdministrator = isSystemAdministrator
  }

  static fromJSON(jsonObject: AdministratorInformationJSON): AdministratorInformationDTO {
    const filteredBucketList: BucketListItem[] = []
    jsonObject.bucketList.forEach((bucket) => {
      const filteredLogoImg = ListUtility.findOne<bucketUrl>(
        bucket.urlList || [],
        item => item.type === 'logoImg',
      )

      filteredBucketList.push({
        id: bucket.id,
        bucketKey: bucket.bucketKey,
        name: bucket.name,
        logoImgUrl: filteredLogoImg ? UrlUtility.buildUrl(filteredLogoImg) : '',
      })
    })

    return new AdministratorInformationDTO(
      filteredBucketList,
      jsonObject.isSystemAdministrator,
    )
  }
}
